<template>
  <!--begin::Navbar-->
  <Teleport v-if="mounted" to="#header-breadcrumbs">
    <CBreadcrumb v-bind="{ routes }" disableGoToBack />
  </Teleport>
  <CCard
    class="py-6 px-4 md:p-6 flex items-start gap-6 lg:gap-[60px] flex-col lg:flex-row"
  >
    <ProfileNavigation
      :menu="menuList"
      @changeProfileRoute="handleChangeProfileRoute"
    />
    <div class="w-full">
      <div class="foo space-y-4">
        <ProfileWrapper
          :title="currentTab?.title"
          :bg="currentTab?.bg"
          :cover="currentTab?.cover"
        >
          <template #suffix v-if="currentTab?.tab === 'profile' && isMobile">
            <RouterLink to="/settings/edit">
              <CButton
                class="h-9 flex-center text-xs"
                variant="info"
                icon="icon-edit-2"
                :text="$t('edit')"
                icon-position="left"
              />
            </RouterLink>
          </template>
        </ProfileWrapper>
        <Transition name="profile" mode="out-in">
          <div :key="currentTab">
            <template v-if="currentTab?.tab === 'profile'">
              <ProfileContent />
            </template>
            <template v-if="currentTab?.tab === 'notification'">
              <ProfileNotifications />
            </template>
          </div>
        </Transition>
      </div>
    </div>
  </CCard>
  <!--end::Navbar-->
</template>

<script lang="ts" setup>
import { computed, ref, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import CBreadcrumb from "@/components/Common/CBreadcrumb.vue";
import { useMounted } from "@/composables/useMounted";
import "dayjs/locale/ru";
import "dayjs/locale/en";
import CCard from "@/components/Card/CardWrapper.vue";
import ProfileNavigation from "@/modules/Profile/components/ProfileNavigation.vue";
import ProfileContent from "@/modules/Profile/components/ProfileContent.vue";
import ProfileWrapper from "@/modules/Profile/components/ProfileWrapper.vue";
import { updateQueryParams } from "@/utils";
import ProfileNotifications from "@/modules/Profile/components/ProfileNotifications.vue";
import { useMobile } from "@/composables/useMobile";
import CButton from "@/components/Common/CButton.vue";
import { usePushToDataLayer } from "@/composables/usePushToDataLayer";
const { pushToDataLayer } = usePushToDataLayer();

const { t } = useI18n();
const { mounted } = useMounted();
const route = useRoute();

const { isMobile } = useMobile("mobile");

const menuList = computed(() => [
  {
    title: t("profile.title"),
    tab: "profile",
    cover: "/images/profile-main.webp",
    bg: "bg-[#f5edfa]",
  },
  {
    title: t("profile.notification"),
    tab: "notification",
    cover: "/images/profile-notifications.webp",
    bg: "bg-[#dff9e8]",
  },
]);

const routes = computed(() => [
  {
    name: t("settings"),
    route: "/settings",
  },
]);
const tabProfile = ref("");
const currentTab = computed(() =>
  menuList.value.find((el) => el?.tab === tabProfile.value),
);

const handleChangeProfileRoute = (tab: string) => {
  tabProfile.value = tab;
  updateQueryParams("profile", tab);
};

watch(
  () => route.query.profile,
  (val) => {
    if (val) {
      tabProfile.value = val;
    } else {
      updateQueryParams("profile", "profile");
    }
  },
  { deep: true, immediate: true },
);

onMounted(() => {
  pushToDataLayer("pageview", {
    page: "profile",
    event_category: "page",
    event_label: "profile_page_view",
    button_text: "None",
  });
});
</script>
<style>
.flex-el {
  flex: 1 1 0;
}
</style>
